/** Shared by InstallPrompt and PushNotificationToggle — both care whether the
 * app is already installed, and iOS needs different instructions than Android/desktop. */
export function detectStandalone(): boolean {
  if (typeof window === 'undefined') return true; // SSR/build: never render
  const iosStandalone = (window.navigator as { standalone?: boolean }).standalone === true;
  return window.matchMedia('(display-mode: standalone)').matches || iosStandalone;
}

export function detectIos(): boolean {
  if (typeof navigator === 'undefined') return false;
  // iPadOS 13+ reports itself as a Mac, so the touch check matters.
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}
